import { render } from "./ProjectPublicationsCreateFormGroupSelector.vue?vue&type=template&id=43f1831f&scoped=true"
import script from "./ProjectPublicationsCreateFormGroupSelector.vue?vue&type=script&lang=js"
export * from "./ProjectPublicationsCreateFormGroupSelector.vue?vue&type=script&lang=js"

import "./ProjectPublicationsCreateFormGroupSelector.vue?vue&type=style&index=0&id=43f1831f&lang=scss&scoped=true"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43f1831f"]])

export default __exports__